var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignatureAndPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 9.69682 2.01587 9.39735 2.04683 9.10237C4.64186 8.24485 6.74165 6.29899 7.80565 3.80535C9.61914 6.34463 12.5907 8 15.949 8C16.8901 8 17.8009 7.86998 18.6643 7.62694C18.8829 8.38009 19 9.17637 19 10C19 14.6944 15.1944 18.5 10.5 18.5C5.80558 18.5 2 14.6944 2 10ZM6.37256 0.888836C2.90896 2.46037 0.5 5.94886 0.5 10C0.5 15.5228 4.97715 20 10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0C9.02829 0 7.63083 0.317927 6.37256 0.888836ZM8.49878 10.5C8.49878 11.3284 7.82721 12 6.99878 12C6.17035 12 5.49878 11.3284 5.49878 10.5C5.49878 9.67157 6.17035 9 6.99878 9C7.82721 9 8.49878 9.67157 8.49878 10.5ZM14 12C14.8284 12 15.5 11.3284 15.5 10.5C15.5 9.67157 14.8284 9 14 9C13.1716 9 12.5 9.67157 12.5 10.5C12.5 11.3284 13.1716 12 14 12Z",
    fill: "#035C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureAndPhoto);
export default __webpack_public_path__ + "static/media/signature-and-photo.3b87cc7dfb0aaa5650f4bda48b3a1874.svg";
export { ForwardRef as ReactComponent };